import EventEmitter from "./EventEmitter";
export default class Network extends EventEmitter {
  constructor() {
    super();
    this.ONLINE = true;
    this.handler = {
      offline: this.onOffline.bind(this),
      online: this.onOnline.bind(this),
    };
    window.addEventListener("offline", this.handler.offline);
    window.addEventListener("online", this.handler.online);
  }
  onOffline() {
    console.log("no Internet connection");
    this.ONLINE = false;
    // alert("Application won't work without Internet connection");
    this.raiseEvent("change", [this.ONLINE]);
  }

  onOnline() {
    console.log("has Internet connection");
    this.ONLINE = true;
    this.raiseEvent("change", [this.ONLINE]);
  }
}
